import React from 'react';
import PropTypes from 'prop-types';
import {withFormsy, propTypes} from "formsy-react";
import {FormGroup, Label, FormFeedback, Input} from 'reactstrap';
import TagsInput from 'react-tagsinput'
import Autosuggest from 'react-autosuggest'
import {FormattedMessage} from "react-intl";

class AutosuggestInput extends React.Component {
    static theme = {
        container: 'react-autosuggest__container',
        containerOpen: 'react-autosuggest__container--open',
        input: 'react-autosuggest__input',
        inputOpen: 'react-autosuggest__input--open',
        inputFocused: 'react-autosuggest__input--focused',
        suggestionsContainer: 'react-autosuggest__suggestions-container dropdown',
        suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open show',
        suggestionsList: 'react-autosuggest__suggestions-list dropdown-menu show',
        suggestion: 'react-autosuggest__suggestion dropdown-item',
        suggestionFirst: 'react-autosuggest__suggestion--first',
        suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
        sectionContainer: 'react-autosuggest__section-container',
        sectionContainerFirst: 'react-autosuggest__section-container--first',
        sectionTitle: 'react-autosuggest__section-title'
    };

    onChange(e, {newValue, method}) {
        if (method === 'enter') {
            e.preventDefault()
        } else {
            this.props.onChange(e)
        }
    }

    render() {
        const {value, tags, addTag, ...rest} = this.props;

        const inputValue = (value && value.trim().toLowerCase()) || '';
        const inputLength = inputValue.length;

        let suggestions = tags.filter((tag) => {
            return tag.name.toLowerCase().slice(0, inputLength) === inputValue
        });

        return (
            <Autosuggest
                suggestions={suggestions}
                shouldRenderSuggestions={() => true}
                getSuggestionValue={(suggestion) => suggestion.value}
                renderSuggestion={(suggestion) => <span>{suggestion.name}</span>}
                inputProps={{...rest, value, onChange: ::this.onChange}}
                onSuggestionSelected={(e, {suggestion}) => {
                    addTag(suggestion)
                }}
                onSuggestionsClearRequested={() => {
                }}
                onSuggestionsFetchRequested={() => {
                }}
                theme={AutosuggestInput.theme}
                focusInputOnSuggestionClick={false}
                renderInputComponent={props => (
                    <Input {...props} />
                )}
            />
        )
    }
}

export class TagInputFormGroup extends React.Component {
    static propTypes = {
        label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        values: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })).isRequired,
        ...propTypes,
    };

    onChange(tags) {
        const possibleValues = this.props.values.map(pv => pv.value);
        const filteredTags = [];
        for (const tag of tags) {
            if (possibleValues.includes(tag.value)) {
                filteredTags.push(tag);
            }
        }

        this.props.setValue(filteredTags);
    }

    render() {
        const {getValue, id, label, values, showError, isPristine, showRequired, isRequired} = this.props;

        const tags = getValue();
        const valid = isPristine() ? undefined : (!showError() && !showRequired());

        return (
            <FormGroup>
                {typeof label !== "undefined" &&
                <Label className={isRequired() ? 'required' : ''} for={id}>
                    {label}
                </Label>
                }

                <FormattedMessage id="advert.new.add_tag" defaultMessage="Add a tag" children={message => (
                    <TagsInput value={tags} onChange={::this.onChange} onlyUnique
                               renderInput={props => (<AutosuggestInput {...props} tags={values}/>)}
                               renderLayout={(tagComponents, inputComponent) => (
                                   <div className="tags">
                                       {tagComponents}
                                       {inputComponent}
                                   </div>
                               )}
                               tagProps={{
                                   className: "tags__item",
                                   classNameRemove: "tags__remove",
                               }}
                               tagDisplayProp='name'
                               renderTag={(props) => {
                                   const {tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other} = props;
                                   return (<span key={key} {...other}>
                                    {getTagDisplayValue(tag)}
                                           {!disabled &&
                                           <a className={classNameRemove} onClick={() => onRemove(key)}>&times;</a>
                                           }
                                </span>
                                   )
                               }}
                               inputProps={{
                                   placeholder: message,
                                   valid: valid
                               }}

                    />
                )}/>


                {!isPristine() && showRequired() &&
                <FormFeedback>
                    <FormattedMessage id="form.error.required" defaultMessage="Field is required"/>
                </FormFeedback>
                }
            </FormGroup>
        )
    }
}

export default withFormsy(TagInputFormGroup);


// WEBPACK FOOTER //
// ./src/components/Form/TagInputFormGroup.jsx